import { useCallback, useEffect, useRef, useState } from 'react';
import { cannedJobAPI } from '../../../services/api';
import { messageFromError } from '../parts/errorMessage';

// A shop's canned jobs. The Settings section owns this hook and fetches for
// itself; nothing here touches the orchestrator's shared loading flag.
// create/update/remove reload the list on success and let a rejection
// propagate, so the editor can show the server's message and keep its values.
export const useCannedJobs = () => {
  const [cannedJobs, setCannedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const reload = useCallback(async () => {
    try {
      const data = await cannedJobAPI.list();
      if (!mounted.current) return;
      setCannedJobs(data?.canned_jobs || []);
      setError('');
    } catch (err) {
      if (!mounted.current) return;
      setError(messageFromError(err, 'Could not load your canned jobs.'));
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const create = async (job) => {
    const created = await cannedJobAPI.create(job);
    await reload();
    return created;
  };

  const update = async (id, job) => {
    const updated = await cannedJobAPI.update(id, job);
    await reload();
    return updated;
  };

  const remove = async (id) => {
    await cannedJobAPI.remove(id);
    await reload();
  };

  return { cannedJobs, loading, error, reload, create, update, remove };
};

export default useCannedJobs;
